// React and Hooks
import { useEffect, useState } from "react";

// React Router
import { useNavigate } from "react-router-dom";

// Constants
import { config, dashboardPath, token, user } from "../../../utils/Constant";

// Components
import CommonLogo from "../../../Component/OtherPages/Authentication/Common/CommonLogo";
import LoginForm from "./form/LoginForm";
import { useAuthLoginMutation } from "../../../ReduxToolkit/api/auth";
import { showApiResultAlert } from "../../../utils/AlertManager/showApiAlert";

const LoginContainer = () => {
  // State for toggling password visibility
  const [showPassword, setShowPassword] = useState(false);

  // Redux dispatch and selector hooks
  const navigate = useNavigate();

  const [mutateLoginEmployee, { isLoading, isError, isSuccess, error, data }] =
    useAuthLoginMutation();

  // Handle form submission
  const handleSubmit = (values: { email: string; password: string }) => {
    mutateLoginEmployee(values);
  };

  useEffect(() => {
    const userDetails = localStorage?.getItem(user);
    const parseUser = userDetails ? JSON.parse(userDetails) : null;
    if (parseUser) {
      navigate(dashboardPath);
    }
  }, []);

  useEffect(() => {
    if (!data || !isSuccess) return;

    const { user: userData, token: userToken, configuration } = data; // now safe

    if (userData && userToken) {
      localStorage.setItem(user, JSON.stringify(userData));
      localStorage.setItem(token, userToken);
      localStorage.setItem(config, JSON.stringify(configuration));
      setTimeout(() => {
        navigate(dashboardPath);
      }, 100);
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (isError) {
      showApiResultAlert({ error: { message: error?.error } }, { title: "" });
    }
  }, [isError]);

  return (
    <div className="login-card login-dark">
      <div>
        {/* Login Form */}
        <div className="login-main">
          {/* Logo Section */}
          <CommonLogo alignLogo="d-flex justify-content-center align-items-center" />

          <LoginForm
            handleSubmit={handleSubmit}
            showPassword={showPassword}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginContainer;
